module.exports = __webpack_public_path__ + "static/media/people-secondary.07283bf3.svg";